import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="bg-slate-900 border-b border-slate-800 sticky top-0 z-50" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex justify-between h-16" data-id="element-105">
          <div className="flex items-center" data-id="element-106">
            <div className="flex-shrink-0 flex items-center space-x-3" data-id="element-107">
              <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center" data-id="element-108">
                <ShieldIcon className="w-5 h-5 text-white" data-id="element-109" />
              </div>
              <div className="flex flex-col" data-id="element-110">
                <span className="text-white font-bold text-lg leading-none tracking-tight" data-id="element-111">
                  Franklin County
                </span>
                <span className="text-emerald-400 text-xs font-medium tracking-wider uppercase mt-1" data-id="element-112">
                  Health Department
                </span>
              </div>
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center space-x-8" data-id="element-113">
            <a href="#" className="text-slate-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-114">
              How It Works
            </a>
            <a href="#" className="text-slate-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-115">
              About Ratings
            </a>
            <a href="#" className="text-slate-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-116">
              Data Sources
            </a>
          </div>
        </div>
      </div>
    </nav>;
}